import logo from './logo.svg';
import './App.css';

import { get } from '@aws-amplify/api';
import awsconfig from './aws-exports';
import React, { useEffect, useState } from 'react'
import AddStock from './AddStock';
import { Outlet, Link } from "react-router-dom";
import { useNavigate, Navigate } from 'react-router-dom';
import Settings from './Settings';
import { Button } from '@aws-amplify/ui-react';
import { useActiveButton } from './ActiveButtonContext';
import { min } from 'moment';
import axios from 'axios';

const myAPI="mktappapi";


const formatNumberWithCommas = (number) => {
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const updateEtfsInfo = async () => {
  console.log("Executing FindEtfsForIc");
  
  try {
      // Replace with the appropriate method (get, post, etc.) and add parameters if needed
      //const response = await axios.get('https://2fydft663cxnyhm3lsdvrp2bxi0celyp.lambda-url.us-east-1.on.aws/');
      const response = await axios.get('https://blqvjhbxl2wsydnd6gds3tq7ae0xrdqk.lambda-url.us-east-1.on.aws/');
      await console.log('updateEtfsInfo : response = ', response.data);
      //let etfStocks = JSON.parse(response.data);
      let etfStocks = response.data;
      //stocks.current = await {"stocks" : etfStocks};
      //stocksDownloaded.current = await true;
      //return response.data;
  } catch (error) {
      console.error('Error calling updateEtfsInfo:', error);
      // Handle error accordingly
  }
 
};

const FindEtfsForIc = ({signOut}) => {
  console.log("I am in FindEtfsForIc");
  const [input, setInput] = useState("");
  let [displayMessage, setDisplayMessage] = useState("");
  const [formData, setFormData] = useState({
    minCap: '',
    maxQuoteSpread: ''
  });
  const { activeButton, setActiveButton } = useActiveButton();

  const handleSubmit = async (event) => {
    await console.log("Executing handleSubmit");
    await setDisplayMessage("Searching...");
    await event.preventDefault();

    let etfs = [];

    let path = '/findEtfsForIc'; 

    let minCap = 0;
    let maxQuoteSpread = 0;

    if (formData.minCap) {
      minCap = formData.minCap.toString().replace(/,/g, '');
    }
    if (formData.maxQuoteSpread) {
      maxQuoteSpread = formData.maxQuoteSpread.toString();
    }

    await console.log(formData); 

    await setDisplayMessage("Getting market data for ETFs");
    await Promise.resolve(updateEtfsInfo())
    .then(async result =>{
      await console.log("handleSubmit : updateEtfsInfo: resp = ", result);
      var passApiStr=await path + "/" + minCap + "/" + maxQuoteSpread;
      await console.log("handleSubmit : passApiStr = "+ passApiStr);
      await setDisplayMessage("Identifying ETFs for Iron Condor");
      //await Promise.resolve(await get(myAPI, passApiStr))
      const response = await get({
        apiName: myAPI,
        path: passApiStr,
      }).response;
      let resp = await response.body.json();
      await Promise.resolve(resp)  
      .then(async () =>{
        //await setDisplayMessage(resp);
        await console.log("handleSubmit : resp = ");
        await console.log(resp);
        etfs = await resp;
      })
      .then(() => {
        navigate('/findIcETFsGrid', { state: { data: etfs } });
      })
      .catch(error => {
        console.log(error.message);
      }) 
    })


    
  };

  const navigate = useNavigate();

  useEffect(()=>{
    navigate(input);
  },[displayMessage])

  const handleClear = () => {
    setFormData({
        minCap: '',
        maxQuoteSpread: ''
    });
    setDisplayMessage("");
  };

  const handleChange = (event) => {
    console.log("Executing handleChange");
    const { name, value } = event.target;
    let formattedValue = value;
    console.log("handleChange : name = " + name);
    console.log("handleChange : value = " + value);
    console.log("handleChange : formattedValue = " + formattedValue);

    // Only format the minCap input with commas
    if (name === 'minCap') {
      // Remove non-numeric characters except commas
      formattedValue = value.replace(/[^0-9]/g, '');
      formattedValue = formatNumberWithCommas(formattedValue);
      console.log("handleChange : modified formattedValue = " + formattedValue);
    }

      setFormData({
          ...formData,
          [name]: formattedValue
      });
      setDisplayMessage("");
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '20vh'
  };

  const inputStyle = {
      margin: '10px',
      padding: '10px',
      width: '300px',
      borderRadius: '5px',
      border: '1px solid #ddd'
  };

  const buttonStyle = {
      margin: '10px',
      padding: '10px 20px',
      borderRadius: '5px',
      border: 'none',
      backgroundColor: '#4CAF50',
      color: 'white',
      cursor: 'pointer'
  };

  return (
    
    <form onSubmit={handleSubmit} style={formStyle}>
      <div>{(
        <div className="blink_me" style={{ fontSize: '36px' }}>{displayMessage}</div>
      )}</div>
        <input 
            type="text" 
            name="minCap" 
            value={formData.minCap} 
            onChange={handleChange} 
            required 
            placeholder="Min Cap"
            style={inputStyle}
        />
        <input 
            type="text" 
            name="maxQuoteSpread" 
            value={formData.maxQuoteSpread} 
            onChange={handleChange} 
            required 
            placeholder="Max Quote Spread (in cents)"
            style={inputStyle}
        />
         
        <div className="menu-row" style={{ width: '33%', display: 'flex', justifyContent: 'center' }}>
          <button type="submit" style={buttonStyle}>Submit</button>
          <button type="button" onClick={handleClear} style={buttonStyle}>Clear</button>
        </div>
    </form>
  )
}

export default FindEtfsForIc;